import { type Variants } from 'framer-motion';

const EASE_OUT_QUART: [number, number, number, number] = [0.16, 1, 0.3, 1];

/** Entrada del card del form: fade + micro-translate. */
export const cardVariants: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, ease: EASE_OUT_QUART },
  },
};

/** Padre que coordina stagger de los fields al entrar. */
export const fieldStaggerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.04, delayChildren: 0.1 },
  },
};

/** Cada field individualmente. */
export const fieldVariants: Variants = {
  hidden: { opacity: 0, y: 6 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.25, ease: EASE_OUT_QUART } },
};

/** Shake horizontal para errores (MFA, etc.). */
export const shakeVariants: Variants = {
  rest: { x: 0 },
  shake: {
    x: [0, -4, 4, -2, 2, 0],
    transition: { duration: 0.3, ease: 'easeInOut' },
  },
};
